{% block verign_dv_accessibility_sw_premium_description %}
    <div class="premium-sub-container">
        <p v-if="hideText == false">
            {{ $tc('verignDvAccessibility.premiumDescription') }}
        </p>
        <p v-else>
            {{ $tc('verignDvAccessibility.premiumSubbedDescription') }}
        </p>
        <sw-entity-purchase-button v-if="hideText == false"></sw-entity-purchase-button>
    </div>
{% endblock %}